import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import NotificationToast from './components/NotificationToast';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import LoadingSpinner from './components/LoadingSpinner';
import Dashboard from './pages/Dashboard';
import Bookings from './pages/Bookings';
import Properties from './pages/Properties';
import Users from './pages/Users';
import Statistics from './pages/Statistics';

export default function App() {
  return (
    <ErrorBoundary>
      <NotificationProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<Navigate to="/login" replace />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/bookings" element={
                <ProtectedRoute allowedRoles={['support', 'owner', 'admin', 'super_admin']}>
                  <Bookings />
                </ProtectedRoute>
              } />
              <Route path="/properties" element={
                <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                  <Properties />
                </ProtectedRoute>
              } />
              <Route path="/users" element={
                <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                  <Users />
                </ProtectedRoute>
              } />
              <Route path="/statistics" element={
                <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                  <Statistics />
                </ProtectedRoute>
              } />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <NotificationToast />
        </AuthProvider>
      </NotificationProvider>
    </ErrorBoundary>
  );
}